/** @jsxImportSource @emotion/react */
import './styles/App.css';
import tw, { styled } from 'twin.macro'
import ProductList from './component/ProductList';
import FilterPanel from './component/FilterPanel';
import withPageContext from './context/withPageContext';
import Box from '@mui/material/Box';
import InventoryPanel from './component/InventoryPanel';
import WorkshopPanel from './component/WorkshopPanel';
import Header from './component/Header';

function App() {
  return (
    <AppWrapper className="App">
      
      <HeaderWrapper>
        <Header />
        {navigator.userAgent !== "ReactSnap" && 
          <>
            <FilterPanel />
          </>
        }
      </HeaderWrapper>
      <ContentWrapper>
        <WorkshopPanel />
        <ProductList />
        <InventoryPanel />
      </ContentWrapper>
    </AppWrapper>
  );
}

export default withPageContext(App);


const AppWrapper = styled(Box)`
  ${tw`
  `}
  
`

const HeaderWrapper = styled.header`
  ${tw``}
`

const ContentWrapper = styled.div`
  ${tw`
    flex
    justify-center
  `}
`